import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TaxReturnType, TaxReturnTypeService } from "../../../../swaggerServices";
import { Subscription } from 'rxjs';
import { ConfigStateService } from '../../config/config-state.service';
import { TenantConfigService } from '../../../shared/services/tenant-config.service';
import { IFormField } from '../../../shared/components/form-field-wrapper/form-field-wrapper.component';
import { ClientNotificationService } from '../../client-notification.service';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { AddUpdateTaxReturnTypeComponent } from './add-update-tax-return-type/add-update-tax-return-type.component';

declare var $: any;

const DISPLAY_DATE_FORMAT = "DD/MM/YYYY HH:mm";

interface IConfigExportTaxReturnType extends IFormField {
  selected: boolean;
  displayUpdatedAt?: string;
  displayCreatedAt?: string;
  type: string;
}

@Component({
    selector: 'app-tax-return-types',
    templateUrl: './tax-return-types.component.html',
    styleUrls: ['./tax-return-types.component.scss'],
    standalone: false
})

export class TaxReturnTypesComponent implements OnInit, OnDestroy {

  @ViewChild('addUpdateTaxReturnTypeModal')
  addUpdateTaxReturnTypeModal: ElementRef;
  @ViewChild('msgModal')
  msgModal: ElementRef;
  subscriptions: Subscription[] = [];
  taxReturnTypes: TaxReturnType[];
  taxReturnTypeSearch: string;
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  configExportMode = false;
  entireListSelected = false;
  configExportDate = "";
  dateValidationRegex = new RegExp("^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$");
  taxReturnTypesForConfigExport: IConfigExportTaxReturnType[];
  selectedTaxReturnTypes = [];
  @ViewChild('configExportConfimationModal') configExportConfimationModal: ElementRef;
  isProductionMode: boolean;
  syncToOneTeamEnabled: boolean = false;

  constructor(
    private typeService: TaxReturnTypeService,
    private config: ConfigStateService,
    private clientNotificationService: ClientNotificationService,
    private dialog: MatDialog) {
    this.isProductionMode = environment.production;
  }

  ngOnInit() {
    this.typeService.getTaxReturnTypes().subscribe((taxReturnTypes: any) => {
      this.taxReturnTypes = taxReturnTypes;
      this.loadTaxReturnTypeForConfigExport();
    });
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias;
        this.syncToOneTeamEnabled = this.config.featureFlags.enableOneteamIntegration;
      })
    );
  };

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  editTaxReturnType(taxReturnType) {
    this.openAddUpdateTaxReturnTypeDialog(taxReturnType);
  }

  addTaxReturnType() {
    this.openAddUpdateTaxReturnTypeDialog(null);
  }

  refresh() {
    this.typeService.getTaxReturnTypes().subscribe((taxReturnTypes: any) => {
      this.taxReturnTypes = taxReturnTypes;
      this.loadTaxReturnTypeForConfigExport();
    });
  }

  toggleConfigExportMode() {
    this.configExportMode = !this.configExportMode;
    if (!this.configExportMode) {
      setTimeout(() =>
        $('.multi-select.dropdown').dropdown({
          placeholder: "All",
          preserveHTML: false,
        }));
    }
  }

  entireListSelection() {
    this.taxReturnTypesForConfigExport.forEach((trt) => trt.selected = this.entireListSelected);
  }

  listSelection() {
    this.taxReturnTypesForConfigExport.forEach((trt) => {
      if (trt.selected === false) return this.entireListSelected = false;
    })
  }

  loadTaxReturnTypeForConfigExport(ids?: string[]) {
    this.taxReturnTypesForConfigExport = this.taxReturnTypes.map((trt: any) => {
      if (ids && !ids.includes(trt.id)) {
        return;
      }
      return {
        selected: false,
        displayCreatedAt: moment(trt.createdAt).format(DISPLAY_DATE_FORMAT).toString(),
        displayUpdatedAt: moment(trt.updatedAt).format(DISPLAY_DATE_FORMAT).toString(),
        ...trt
      }
    }).filter(trt => trt);
  }

  filterTaxReturnTypeOnDateChange() {
    if (!this.configExportDate.length) {
      this.loadTaxReturnTypeForConfigExport();
      return;
    }
    if (this.dateValidationRegex.test(this.configExportDate)) {
      this.typeService.getUpdatedTaxReturnTypeByDate(this.configExportDate).subscribe((ids) => {
        this.loadTaxReturnTypeForConfigExport(ids);
      });
    }
  }

  openConfigExportConfimationModal() {
    this.selectedTaxReturnTypes = this.taxReturnTypesForConfigExport.map((trt) => {
      if (trt.selected) { return { id: trt.id, type: trt.type, displayUpdatedAt: trt.displayUpdatedAt } }
    }).filter(tt => tt);
    $(this.configExportConfimationModal.nativeElement).modal("show");
    $(this.configExportConfimationModal.nativeElement).scrollTop($(this.configExportConfimationModal.nativeElement)[0].scrollHeight);
  }

  clearSelectedSources() {
    this.taxReturnTypesForConfigExport.forEach((q) => q.selected = false);
  }

  downloadConfig() {
    if (!this.selectedTaxReturnTypes.length) { return; };
    const taxReturnTypeIds = this.selectedTaxReturnTypes.map(trt => trt.id);
    this.typeService.downloadConfigExportTaxReturnType({ taxReturnTypeIds }).subscribe(data => {
      if (!data.fileContent) {
        this.clientNotificationService.appendMessage("File couldn't be fetched, please try again later", "Download config", false);
        return;
      }
      var elem = window.document.createElement('a');
      elem.href = "data:application/json," + encodeURIComponent(data.fileContent);
      elem.download = data.fileName ? data.fileName : "package";
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
      this.clearSelectedSources();
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    }, error => {
      $(this.configExportConfimationModal.nativeElement).modal("hide");

    })
  }

  private openAddUpdateTaxReturnTypeDialog(taxReturnType: TaxReturnType | null) {
    this.dialog.open(AddUpdateTaxReturnTypeComponent, {
      width: '640px',
      data: taxReturnType,
      autoFocus: 'input',
    }).afterClosed().subscribe(updated => {
      if (updated) {
        this.refresh();
      }
    });
  }
}
